interface IDisplayProps {
  moduleName: string;
  isMobile: boolean;
  message: string;
}

export const DisplayError = ({ moduleName, message }: Omit<IDisplayProps, 'isMobile'>) => (
  <div data-module="display-error" style={{ background: 'red', height: '100px', width: '100%' }}>
    <div>{`Error: ${moduleName}`}</div>
    <div>{message}</div>
  </div>
);

export const DisplayLoading = ({ moduleName, isMobile }: Omit<IDisplayProps, 'message'>) => {
  if (isMobile) {
    return <div className="suspense-loading isMobile" data-module-lazy={moduleName} />;
  }
  return <div className="suspense-loading" data-module-lazy={moduleName} />;
};
